'use client';
import { useEffect, useState } from 'react';

// T is a generic type for value parameter, our case this will be string
function useDebounce<T = string>(value: T, delay: number, callback?: () => void): T {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
        // if is completely optional to do some post processing(for e.g. setting value into store state, etc.)
        callback?.();
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay, callback], // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}

export { useDebounce };
